export enum NoticeType {
  NONE = "",
}
